<div id="Historial" [ngClass]="{ view: view }">
  <div class="historial_container">
    <div class="historial_header">
      <div
        class="item"
        [ngClass]="{ selected: selected == Tabs.record }"
        (click)="selected = Tabs.record"
      >
        <p>{{ Tabs.record }}</p>
      </div>
      <div
        class="item"
        [ngClass]="{ selected: selected == Tabs.comments }"
        (click)="selected = Tabs.comments"
      >
        <p>{{ Tabs.comments }}</p>
      </div>
      <div
        class="item"
        [ngClass]="{ selected: selected == Tabs.files }"
        (click)="selected = Tabs.files"
      >
        <p>{{ Tabs.files }}</p>
      </div>
      <div>
        <i class="fas fa-arrow-right" (click)="clickHidden()"></i>
      </div>
    </div>
    <div class="content">
      <case-record *ngIf="selected == Tabs.record"></case-record>
      <case-comment *ngIf="selected == Tabs.comments"></case-comment>
      <case-files-ras *ngIf="selected == Tabs.files"></case-files-ras>
    </div>
  </div>
</div>
